import { render, staticRenderFns } from "./TopicalLiaisonComponent.vue?vue&type=template&id=a8e428de&"
import script from "./TopicalLiaisonComponent.vue?vue&type=script&lang=js&"
export * from "./TopicalLiaisonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports